import { faSortDown, faSortUp } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import {
  LoaderWrapper,
  ManageFeeLayout,
  SliderPanel,
} from "../../../components";
import SpecificationFilterCard from "./SpecificationFilterCard";
import SpecificationInformationCard from "./SpecificationInformationCard";
import Logo from "../../../assets/empty-specification.svg";
import { Button } from "react-bootstrap";
import {
  manageFeeFormNames,
  formFields,
  getPathWithParam,
  MANAGE_FEE_ROUTES,
} from "../../../utils";
import InfiniteScroll from "react-infinite-scroller";
import { getFeeSpecificationBasedOnSearchCriteria } from "../../../services";
import { useDeepEffect } from "../../../abstracts";
import { useHistory } from "react-router-dom";

const data = [
  {
    Name: "$ 1000 Plan",
    Description:
      "$ 1000 pro - rate across all participants fixed amount payroll processing fee",
    FeeType: "Balance based",
    AllocationType: "Fixed Amount",
  },
  {
    Name: "$ 4500 Plan",
    Description: "$ 5 if balance between 5000 to 10000",
    FeeType: "Investment based",
    AllocationType: "Tiered",
  },
  {
    Name: "$ 5480 Plan",
    Description: "-",
    FeeType: "Balance based",
    AllocationType: "Percentage",
  },
  {
    Name: "$ 6540 Plan",
    Description: "$ 2000 pro - rate across all participants",
    FeeType: "Balance based",
    AllocationType: "Fixed Amount",
  },
  {
    Name: "$ 170000 Plan",
    Description: "$ 2000 pro - rate across all participants",
    FeeType: "Investment based",
    AllocationType: "Tiered",
  },
];

const tableHeader = [
  {
    label: "Name",
    columnName: "Name",
    width: "28%",
  },
  {
    label: "Description",
    columnName: "Description",
    width: "25%",
  },
  {
    label: "Fee Type",
    columnName: "FeeType",
    width: "25%",
  },
  {
    label: "Allocation Type",
    columnName: "AllocationType",
    // width: "16.66%",
  },
];
const sorterUp = (sortBy) => (a, b) =>
  a[sortBy]?.toLowerCase() > b[sortBy]?.toLowerCase() ? 1 : -1;
const sorterDown = (sortBy) => (a, b) =>
  a[sortBy]?.toLowerCase() < b[sortBy]?.toLowerCase() ? 1 : -1;

const ManageSpecificationContainer = () => {
  const history = useHistory();
  const [listSpecification, setListSpecification] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sliderOpen, setSliderOpen] = useState(false);
  const buttons = [
    {
      label: "Create Specification",
      variant: "primary",
      type: "submit",
      onClick: () => {
        history.push(
          getPathWithParam({
            path: MANAGE_FEE_ROUTES.CREATE_SPECIFICATION_INFORMATION,
          })
        );
      },
    },
  ];

  const sliderOpenFunction = () => {
    setSliderOpen(true);
  };
  //instead of append and setAppend

  const formName = manageFeeFormNames.MANAGE_SPECIFICATION_INFORMATION;
  const fields = formFields[formName];
  const [filterData, setFilterData] = useState({
    feeType: null,
    searchString: "",
    allocationType: null,
    from: 0,
    to: 20,
    count: 0,
  });
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  useDeepEffect(() => {
    setIsLoading(true);
    getFeeSpecificationBasedOnSearchCriteria(filterData)
      .then((response) => {
        if (response?.feeSpecificationInformationDetails?.length < 20)
          setStopInfiniteScroll(true);
        if (append) {
          setListSpecification((feeSpecList) => {
            return [
              ...feeSpecList,
              ...response?.feeSpecificationInformationDetails,
            ];
          });
        } else {
          setListSpecification(response?.feeSpecificationInformationDetails);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [filterData]);
  // useDeepEffect(() => {

  //   if (!append) {

  //     setDataLoad(true);

  //   }

  //   setIsLoading(true);

  //   getFeeSpecificationBasedOnSearchCriteria(filterData)

  //     .then((response) => {

  //       setDataLoad(false);

  //       setIsLoading(false);

  //       if (

  //         response?.feeSpecificationInformationDetails <

  //         20

  //       )

  //         setStopInfiniteScroll(true);

  //       if (append) {

  //         setListSpecification([

  //           ...listSpecification,

  //           ...response?.feeSpecificationInformationDetails,

  //         ]);

  //       } else {

  //         setListSpecification(response?.feeSpecificationInformationDetails);

  //       }

  //       setIsLoading(false);

  //       // dispatch(

  //       //   setManagePageLevelData({

  //       //     formName: formName,

  //       //     fieldData: request,

  //       //   })

  //       // );

  //     })

  //     .catch((error) => {

  //       // Handle Errors

  //       setIsLoading(false);

  //     });

  // }, [filterData]);

  return (
    <ManageFeeLayout className="calculation-container-fee" buttons={buttons}>
      <LoaderWrapper isLoading={isLoading} className="disableoverflow">
        <SpecificationFilterCard
          filterData={filterData}
          setFilterData={setFilterData}
        />

        {listSpecification.length == 0 ? (
          <>
            <div className="d-flex justify-content-center ">
              <img
                className="img transactionLogo"
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={Logo}
              />
            </div>
            <Button style={{ marginLeft: "41%", marginBottom: "-6%" }}>
              Create Specification
            </Button>
            <div
              className="text-align-center"
              style={{ marginLeft: "42%", marginTop: "-45px" }}
            >
              No Records Found
            </div>
          </>
        ) : (
          <>
            {/* div for loader and InfiniteScroll */}
            <div>
              {listSpecification.length < 10 ? (
                <div className="fw-400 ft-16 grey">
                  {0 + "" + listSpecification.length} Records Found
                </div>
              ) : (
                <div className="fw-400 ft-16 grey">
                  {listSpecification.length} Records Found
                </div>
              )}
              <br />

              <div
                className="payroll-columns w-100"
                style={{ display: "flex", marginLeft: "20px" }}
              >
                {tableHeader.map((item, ind) => (
                  <div
                    className="fw-600 ft-14 grey"
                    style={{ width: item?.width }}
                  >
                    {item?.label}{" "}
                  </div>
                ))}
              </div>
              <div
                style={{
                  height: "54vh",
                  overflow: "scroll",
                }}
              >
                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => {
                    setAppend(true);
                    setFilterData((filterData) => {
                      return {
                        ...filterData,
                        from: listSpecification?.length,
                      };
                    });
                  }}
                  hasMore={!stopInfiniteScroll}
                  initialLoad={false}
                  threshold={100}
                  useWindow={false}
                  loader={
                    listSpecification.length != 0 && (
                      <div className="loader" key={0}>
                        Loading ...
                      </div>
                    )
                  }
                >
                  {listSpecification.map((data, index) => {
                    return (
                      <div>
                        <SpecificationInformationCard listdata={data} />
                      </div>
                    );
                  })}
                </InfiniteScroll>
              </div>
            </div>
          </>
        )}
      </LoaderWrapper>
    </ManageFeeLayout>
  );
};

export default ManageSpecificationContainer;
